import { useCallback, useState } from 'react';
import { PostOptimizationEditState } from './post-optimization-constants';

export type { PostOptimizationEditState } from './post-optimization-constants';

export interface UsePostOptimizationEditsReturn {
  edits: Map<string, PostOptimizationEditState>;
  updateEdit: (rowId: string, edits: PostOptimizationEditState) => void;
  resetChanges: () => void;
}

/** Track in-session post-optimization edits by table row ID. */
export const usePostOptimizationEdits = (): UsePostOptimizationEditsReturn => {
  const [edits, setEdits] = useState<Map<string, PostOptimizationEditState>>(new Map());

  const updateEdit = useCallback((rowId: string, newEdits: PostOptimizationEditState) => {
    setEdits(previousEdits => {
      const nextEdits = new Map(previousEdits);
      const existingEdits = nextEdits.get(rowId) || {};
      nextEdits.set(rowId, { ...existingEdits, ...newEdits });
      return nextEdits;
    });
  }, []);

  const resetChanges = useCallback(() => {
    setEdits(new Map());
  }, []);

  return { edits, updateEdit, resetChanges };
};
